import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import MissionVission from "../../components/MissionVission/MissionVission";
import About4 from "../../components/about4/about4";
import Skill2 from "../../components/Skill2/Skill2";
import TeamSection from "../../components/TeamSection/TeamSection";
import Testimonial from "../../components/Testimonial/Testimonial";
import FunFact from "../../components/FunFact/FunFact";
import { getBusinessSettings } from "../../api/getBusinessSettings";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/ctaSection/ctaSection";
import Navbar2 from "../../components/Navbar2/Navbar2";
import img from "../../images/coffee-processing.jpg";
import StarLoader from "../../components/loader/StarLoader";
import { getTeams } from "../../api/team";

const AboutPage = () => {
  const [settings, setSettings] = useState(null);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const [settingData, teamData] = await Promise.all([
          getBusinessSettings(),
          getTeams(),
        ]);
        setSettings(settingData);
        setTeams(teamData);
      } catch (error) {
        console.error("Error fetching business settings:", error);
      } finally {
        setLoading(false); // ✅ stops loading after real fetch completes
      }
    };

    fetchSettings();
  }, []); // ✅ runs once only

  if (loading) {
    return <StarLoader />; // ✅ show loader while fetching
  }

  if (!settings) {
    return (
      <p style={{ textAlign: "center", marginTop: "100px" }}>
        No datas found found from settings.
      </p>
    );
  }

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle pageTitle={"About Us"} pagesub={"About"} img={`${img}`} />
      <MissionVission settings={settings} />
      <About4 settings={settings} />
      <Skill2 />
      <TeamSection teams={teams} tClass={"wpo-team-section-s3"} />
      <Testimonial />
      <FunFact fClass={"wpo-fun-fact-section-s2 pt-0"} />
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutPage;
